import React from 'react'
import useSelectedDepartmentIds from 'support/hooks/use-selected-department-ids'

export default function WhenMultipleDepartmentsAreSelected ({ children, negate = false }) {
  const [selctedDepartmentIds] = useSelectedDepartmentIds()

  const check = (selctedDepartmentIds.length > 1 && negate === false) || ((selctedDepartmentIds.length > 1) === false && negate !== false)

  return check ? children : null
}
